import React, { useEffect, useState } from 'react';
import { onUserDataRead } from '../../actions';
import { useSelector, useDispatch } from 'react-redux';
import './Home.scss';
import { Layout, message, Tabs, Button, Tooltip } from 'antd';
import '../../scss/primaryButton.scss';
import '../../scss/secondButton.scss';
import '../../scss/linkButton.scss';
import Spin from '../../components/Spin';
import PatientProfileCard from '../../components/PatientProfileCard/PatientProfileCard';
import { useHistory } from 'react-router-dom';
import LogoEmpresaFooter from '../../assets/img/a1-8.png';
import LogoEmpresa from '../../assets/img/a-iso-blanco-8.png';
import PdfReports from '../PdfReports';
import Prescriptions from '../Prescriptions/Prescriptions';
import { getAccessTokenApi, logout } from '../../api/auth';
import {
  FileTextOutlined,
  MedicineBoxOutlined,
  LogoutOutlined,
} from '@ant-design/icons';

const { Header, Content, Footer } = Layout;

export default function Home() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('studies');

  const { user, loading } = useSelector((store) => store.userData);
  const {
    portalTheme,
    organization,
    organizationDescription,
    tenantLogo,
    tenant,
  } = useSelector((store) => store.tenantData);

  useEffect(() => {
    const getData = async () => {
      const token = await getAccessTokenApi();
      if (!token) {
        history.push('/login');
        message.warning('Sesión expirada..');
        return;
      }
      dispatch(onUserDataRead());
    };

    getData();
  }, [dispatch, history]);

  const goToPortalHome = () => {
    history.push('/');
  };

  const handleLogout = () => {
    logout('manual');
  };

  if (loading || !user?.dni) {
    return <Spin />;
  }

  const tabItems = [
    {
      key: 'studies',
      label: (
        <span className="home-tab-label">
          <FileTextOutlined />
          Estudios
        </span>
      ),
      children: <PdfReports />,
    },
    {
      key: 'prescriptions',
      label: (
        <span className="home-tab-label">
          <MedicineBoxOutlined />
          Prescripciones
        </span>
      ),
      children: <Prescriptions />,
    },
  ];

  return (
    <Layout className="home-layout">
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: portalTheme?.primaryColor,
          padding: '0 15px',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
        }}
      >
        <div className="logo-container">
          <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '16px' }}>
            Portal {organization}
          </span>
        </div>

        <div style={{ display: 'flex', gap: '8px' }}>
          <Button
            type="primary"
            ghost
            icon={
              <img src={LogoEmpresa} alt="Logo" style={{ height: '24px' }} />
            }
            onClick={goToPortalHome}
            className="header-home-button"
          >
            <span className="header-home-button__text">Inicio</span>
          </Button>
          <Tooltip title="Cerrar Sesión">
            <Button
              type="link"
              ghost
              icon={<LogoutOutlined />}
              onClick={handleLogout}
              style={{ color: '#fff' }}
            />
          </Tooltip>
        </div>
      </Header>

      <Content className="home-content">
        <div className="organization-small-banner">
          <img
            src={`https://storage.googleapis.com/bs-proyecto1.appspot.com/${tenant}/${
              tenantLogo || 'logo'
            }.png`}
            alt="Logo"
            className="organization-logo"
          />
          <div className="organization-info">
            <span className="organization-name">{organization}</span>
            {organizationDescription && (
              <span className="organization-description">
                {organizationDescription}
              </span>
            )}
          </div>
        </div>

        <PatientProfileCard patient={user} />

        <div className="home-content-tabs">
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={tabItems}
            size="small"
            destroyInactiveTabPane
            className="home-main-tabs"
          />
        </div>
      </Content>

      <Footer
        style={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
          padding: '15px 10px',
          background: '#f5f5f5',
          fontSize: '12px',
        }}
      >
        <div>© 2024 Portal de Turnos - AmpinaSoft</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img
            src={LogoEmpresaFooter}
            alt="AmpinaSoft"
            style={{ height: '24px' }}
          />
          <a
            href="https://ampinasoft.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#1890ff',
              fontWeight: 'bold',
              textDecoration: 'none',
            }}
          >
            Descubre nuestros servicios
          </a>
        </div>
      </Footer>
    </Layout>
  );
}
